import React, { useRef } from 'react';
import { Message, toaster } from 'rsuite';
import * as S from './styles';
import { useAuth } from '../../../hooks/auth';
import api from '../../../services/api';
import RModal from '../../Rsuite/Modal';
import { CustomButton } from '../../CustomButton';
import { Label } from '../../Label';
import { CustomInput } from '../../CustomInput';
import { Spacer } from '../../Spacer';
import { CustomInputNumber } from '../../CustomInputNumber';

export const CreateEditGroupAditionals = ({
  open,
  close,
  currentGroup,
  handleAddAdditionalGroup,
  handleEditAdditionalGroup,
}) => {
  const { id_empresa } = useAuth();
  const descriptionRef = useRef(null);
  const MaxQuantityRef = useRef(null);
  const pdvRef = useRef(null);

  async function handleSubmit() {
    const description = descriptionRef.current.value;
    const pdvRefValue = pdvRef.current.value;
    const pdvCode = pdvRefValue === '' ? 0 : Number(pdvRefValue);
    const maxQtdRefValue = Number(MaxQuantityRef.current.value);
    const maxQuantity =
      Number.isNaN(maxQtdRefValue) || maxQtdRefValue < 1
        ? null
        : maxQtdRefValue;

    if (!description || Number.isNaN(pdvCode)) {
      toaster.push(
        <Message showIcon type="error">
          Preencha os campos corretamente.
        </Message>,
      );
      return;
    }

    if (!!currentGroup?.Id) {
      editAdditionalGroup(description, pdvCode, maxQuantity);
      return;
    }

    createAdditionalGroup(description, pdvCode, maxQuantity);
  }

  async function createAdditionalGroup(description, pdvCode, maxQuantity) {
    const additionalGroup = {
      CodigoPDV: pdvCode,
      IdEmpresa: id_empresa,
      Descricao: description,
      QtdMaxima: maxQuantity,
      Sequencia: 0,
      Ativo: true,
      IsAdicional: true,
    };

    try {
      const response = await api.post('/grupo-produto/criar', additionalGroup);

      if (response.status !== 201) {
        toaster.push(
          <Message showIcon type="error">
            Não foi possivel criar o grupo.
          </Message>,
        );
        return;
      }

      handleAddAdditionalGroup(response.data);
      close();
    } catch (err) {
      console.log(err);
    }
  }

  async function editAdditionalGroup(description, pdvCode, maxQuantity) {
    try {
      const updateGroup = {
        Descricao: description,
        CodigoPDV: pdvCode,
        QtdMaxima: maxQuantity,
      };

      const response = await api.patch(
        `/grupo-produto/alterar/${currentGroup?.Id}`,
        updateGroup,
      );

      if (response.status !== 200) {
        toaster.push(
          <Message showIcon type="error">
            Não foi possivel editar o grupo.
          </Message>,
        );
        return;
      }

      handleEditAdditionalGroup(response.data);
      close();
    } catch (err) {
      console.log(err);
    }
  }

  async function removeAdditionalGroup() {
    try {
      const updateGroup = {
        Ativo: !currentGroup?.Ativo,
      };

      const response = await api.patch(
        `/grupo-produto/alterar/${currentGroup?.Id}`,
        updateGroup,
      );

      if (response.status !== 200) {
        toaster.push(
          <Message showIcon type="error">
            Não foi possivel remover o grupo.
          </Message>,
        );
        return;
      }

      handleEditAdditionalGroup(response.data);
      close();
    } catch (err) {
      console.log(err);
    }
  }

  return (
    <RModal
      open={open}
      onClose={close}
      title={`${!!currentGroup.Id ? 'Editar' : 'Cadastrar'} Grupo Adicionais`}
      size="md"
      footer={
        <S.Footer>
          {!!currentGroup?.Id ? (
            <CustomButton 
              appearance="ghost" 
              color={currentGroup?.Ativo ? 'red' : 'green'} 
              onClick={removeAdditionalGroup}
            >
              {currentGroup?.Ativo ? 'Desativar' : 'Ativar'}
            </CustomButton>
          ) : <div/>}

          <div>
            <CustomButton appearance="default" onClick={close}>
              Fechar
            </CustomButton>
            <CustomButton onClick={handleSubmit}>Salvar</CustomButton>
          </div>
        </S.Footer>
      }
    >
      <Label>Descrição</Label>
      <CustomInput
        placeholder="Descriçao"
        inputRef={descriptionRef}
        style={{ minWidth: 300 }}
        defaultValue={currentGroup?.Descricao ?? ''}
      />

      <Spacer y={10} />

      <S.Row>
        <S.Column>
          <Label>Codigo PDV</Label>
          <CustomInputNumber
            placeholder="Codigo PDV"
            inputRef={pdvRef}
            defaultValue={currentGroup?.CodigoPDV ?? ''}
          />
        </S.Column>

        <S.Column>
          <Label>Quantidade Max. adicionais</Label>
          <CustomInputNumber
            placeholder="Qtd. Max. adicionais"
            inputRef={MaxQuantityRef}
            defaultValue={currentGroup?.QtdMaxima ?? ''}
          />
        </S.Column>
      </S.Row>
    </RModal>
  );
}
